import { render, staticRenderFns } from "./DoubleColumnChart.vue?vue&type=template&id=65493432&scoped=true"
import script from "./DoubleColumnChart.vue?vue&type=script&lang=js"
export * from "./DoubleColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65493432",
  null
  
)

export default component.exports